<template>
    <v-list>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/empleados">
            <v-list-tile-action>
                <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Empleados')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider> 
        <v-divider v-if="$store.getters.getShipmentsAccess === true"></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/historial">
            <v-list-tile-action>
                <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Historial')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
                <v-list-tile
                v-if="providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/reservations_beneficiary">
            <v-list-tile-action>
                <v-icon>event_note</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile>Reservas de Parqueo</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
                <v-list-tile
                v-if="providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/transportistas">
            <v-list-tile-action>
                <v-icon>local_shipping</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile>Transportistas</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/areas">
            <v-list-tile-action>
                <v-icon>store</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Areas')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('configuracion')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/proveedores">
            <v-list-tile-action>
                <v-icon>airport_shuttle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('proveedores')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-divider v-if="providerHasParkingModule"></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Ayuda')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "admin_proveedor",
        computed: {
                    ...mapGetters(['getProfile', 'providerHasParkingModule'])
        },
        data () {
            return {
            }
        }
    }
</script>
